import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { SearchReturnType } from '@atlassian/jira-servicedesk-insight-async-paginated-hook/src/controllers/types.tsx';
import type { CmdbObject } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/cmdb-object.tsx';

type IssueId = string;

const RESULTS_PER_PAGE = 50;

type RestResult = {
	size: number;
	hasNextPage: boolean;
	results: CmdbObject[];
	total?: number;
};

// @ts-expect-error - TS7031 - Binding element 'size' implicitly has an 'any' type. | TS7031 - Binding element 'hasNextPage' implicitly has an 'any' type. | TS7031 - Binding element 'results' implicitly has an 'any' type. | TS7031 - Binding element 'total' implicitly has an 'any' type.
const transform = ({ size, hasNextPage, results, total }): RestResult => ({
	size,
	hasNextPage,
	// @ts-expect-error - TS7006 - Parameter 'entry' implicitly has an 'any' type.
	results: results.map((entry) => ({
		...entry,
		// @ts-expect-error - TS7006 - Parameter 'att' implicitly has an 'any' type.
		attributes: entry.attributes.map((att) => ({
			...att,
			type: att.objectTypeAttribute.type,
		})),
	})),
	total,
});

let abortController: AbortController | null = null;
export const searchCmdbObjects = async (
	autoCompleteUrl: string,
	query: string,
	issueId?: IssueId,
	// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
	fieldValueMap: {
		[key: string]: string;
	},
	page = 0,
): Promise<SearchReturnType<CmdbObject>> => {
	if (abortController && abortController.abort) {
		abortController.abort();
	}
	abortController = new AbortController();

	const result = await fetchJson(
		`${autoCompleteUrl}start=${RESULTS_PER_PAGE * page}&limit=${RESULTS_PER_PAGE}`,
		{
			method: 'POST',
			body: JSON.stringify({
				query,
				issueId,
				fieldValueMap,
			}),
			signal: abortController.signal,
		},
	).then(transform);

	return {
		results: result.results,
		fetchNextPage: result.hasNextPage
			? () => searchCmdbObjects(autoCompleteUrl, query, issueId, fieldValueMap, page + 1)
			: undefined,
		total: result.total,
	};
};
